class ArticleHeroShare extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleClick = this.handleClick.bind(this)
    this.addEventListener('click', this.handleClick)
  }

  handleClick (event) {
    const btn = event.target.closest('[data-article-hero-share]')
    if (!btn) return

    const shareTitle = btn.dataset.shareTitle
    const shareUrl = btn.dataset.shareUrl
    const label = btn.querySelector('.sec-ArticleHero_ShareLabel')
    const copiedLabel = btn.dataset.shareLabel

    if (navigator.share) {
      navigator.share({ title: shareTitle, url: shareUrl }).catch(() => {})
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(shareUrl).then(() => {
        label.textContent = copiedLabel
      })
    }
  }
}

if (!customElements.get('article-hero-share')) {
  customElements.define('article-hero-share', ArticleHeroShare)
}
